import React, { useEffect, useState } from 'react'

export default ({ time, callback }) => {
  const calculateTimeLeft = () => {
    const difference = +time - +new Date()
    let timeLeft = {}

    if (difference > 0) {
      timeLeft = {
        // hours: Math.floor((difference / (1000 * 60 * 60)) % 24),
        minutes: Math.floor((difference / 1000 / 60) % 60),
        seconds: Math.floor((difference / 1000) % 60),
      }
    }

    return timeLeft
  }

  const [callbackExecuted, setCallbackExecuted] = useState(false)
  const [timeLeft, setTimeLeft] = useState(calculateTimeLeft())

  useEffect(() => {
    const timer = setTimeout(() => {
      setTimeLeft(calculateTimeLeft())
    }, 1000)

    return function cleanup() {
      clearTimeout(timer)
    }
  })

  const timerComponents = []

  Object.keys(timeLeft).forEach((interval) => {
    timerComponents.push(timeLeft[interval])
  })

  const formatTime = () => {
    const formattedTime = timerComponents.join(':')
    return formattedTime
  }

  useEffect(() => {
    if (!timerComponents.length && !callbackExecuted) {
      callback()
      setCallbackExecuted(true)
    }
  }, [callback, timerComponents.length])

  return (
    <div className="countdown_timer">
      {timerComponents.length && formatTime(timerComponents)}
    </div>
  )
}
